<template>
  <div class="h-screen">
    <Layout v-if="$store.getters.isLogged"/>
    <Login v-else/>
  </div>
</template>

<script>
import Login from "./views/Login";
import Layout from "./views/layout/Layout";

export default {
  name: "App",
  components: { Login, Layout }
};
</script>
